import React from 'react';
import { Button, Alert, Group, Text, Box, Progress, ThemeIcon } from '@mantine/core';
import { IconInfoCircle, IconAlertTriangle, IconLock } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useSubscriptionFeatures } from '../hooks/useSubscriptionFeatures';

/**
 * Banner component that displays subscription status information 
 * and upgrade prompts based on the user's subscription tier
 */
export function ConversationLimitBanner() {
  const { 
    subscriptionTier,
    isTrialActive,
    trialDaysRemaining,
    isPremium,
    isBasic,
    canUseVoice,
    isFree
  } = useSubscriptionFeatures();

  // Show trial banner (highest priority)
  if (isTrialActive) {
    return (
      <Alert 
        color="blue" 
        icon={<IconInfoCircle size={16} />}
        title="Voice Connect Trial"
        withCloseButton={false}
        mb="md"
      >
        <Group justify="space-between" align="center">
          <Text size="sm">
            You have {trialDaysRemaining} {trialDaysRemaining === 1 ? 'day' : 'days'} left in your Voice Connect trial
          </Text>
          <Button 
            component={Link} 
            to="/settings/subscription" 
            size="xs" 
            variant="light"
          >
            Upgrade Now
          </Button>
        </Group>
      </Alert>
    );
  }
    
  // Don't show any banner for Premium users on paid plans (not trials)
  if (isPremium) {
    return null;
  }
  
  // Show basic tier banner that promotes premium features
  if (isBasic) {
    return (
      <Alert 
        color="blue" 
        icon={<IconInfoCircle size={16} />}
        title="Basic Plan"
        withCloseButton={false}
        mb="md"
      >
        <Group justify="space-between" align="center">
          <Text size="sm">
            Upgrade to Voice Connect for voice conversations and advanced features
          </Text>
          <Button 
            component={Link} 
            to="/settings/subscription" 
            size="xs" 
            variant="light"
          >
            Upgrade to Voice Connect
          </Button>
        </Group>
      </Alert>
    );
  }

  // Show banner for free users
  return (
    <Alert 
      color="blue" 
      icon={<IconInfoCircle size={16} />}
      title="Free Plan"
      withCloseButton={false}
      mb="md"
    >
      <Group justify="space-between" align="center">
        <Text size="sm">
          Upgrade to start meaningful conversations and unlock premium features
        </Text>
        <Button 
          component={Link} 
          to="/settings/subscription" 
          size="xs" 
          variant="filled"
          className="bg-[#C2A4D6] hover:bg-[#B390C9] text-white rounded-full"
        >
          View Plans
        </Button>
      </Group>
    </Alert>
  );
}